import AnalyticsActionCreator from '../actions/AnalyticsActionCreator';

const AnalyticsUtil = {
  analyticAction(
    apath,
    actionToBe,
    descriptionOFEvent,
    eventTriggered,
    isBeneficiaryEvent
  ) {
    let param = {};
    if (
      typeof descriptionOFEvent === 'string' ||
      descriptionOFEvent instanceof String
    ) {
      param.description = descriptionOFEvent;
    } else if (descriptionOFEvent instanceof Object) {
      param = descriptionOFEvent;
    }
    if (eventTriggered !== undefined) {
      param.event = eventTriggered;
    }
    AnalyticsActionCreator.track(
      {
        path: apath,
        action: actionToBe,
      },
      param,
      undefined,
      undefined,
      isBeneficiaryEvent
    );
  },
};

export default AnalyticsUtil;
